import { createSlice } from "@reduxjs/toolkit";

const designViewerSlice = createSlice({
  name: "isFileAnOlderVersion",
  initialState: false,
  reducers: {
    setIsFileAnOlderVersion: (_state, action) => action.payload,
  },
});

export const { setIsFileAnOlderVersion } = designViewerSlice.actions;

export const isFileAnOlderVersion = designViewerSlice.reducer;

export default designViewerSlice.reducer;
